<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <div class="vx-row">
            <div class="x-col w-full m:w-2/2 lg:w-2/2 mb-1 ml-4">
                <vs-button color="success" size="samll" icon-pack="feather" @click="nowStatic()"><small class="ml-4">*지금 시점(최신)에 통계를 보고 싶으시면 버튼을 눌러주세요.</small></vs-button>
            </div>
            <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
                <vx-card title="재원환자 통계">
                    <canvas id="patient_chart_default"></canvas>
                </vx-card>
            </div>
            <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
                <vx-card title="입원/퇴원/외래 통계">
                    <canvas id="patient_chart"></canvas>
                </vx-card>
            </div>
            <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
                <vx-card title="월별 원장님별 신입 통계">
                    <div class="vx-col w-full xl:w-1/1 mb-base text-center" id="patientChartDoctorBtn" style="display:flex; flex-direction:row; justify-content:center;">
                        <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonthNewPatient"></vs-button>

                        <span class="ml-5 mr-5 mt-2">{{ this.targetDate.substring(0, 4) }}년{{ this.targetDate.substring(4, 6) }}월</span>

                        <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonthNewPatient"></vs-button>
                    </div>
                    <div id="patientChartDoctorDiv" >
                        <canvas id="patientChartDoctor"></canvas>
                    </div>
                </vx-card>
            </div>
            <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
                <div class="vx-col w-full sm:w-1/1 lg:w-1/1 mb-base">
                    <vx-card title="4개월간 신입환자 통계">
                        <table id="list" style="width:100%;" class="border-collapse">
                            <colgroup>
                                <col v-for="(item, index) in newPatientFourMonths" :key="index" :width="newPatientFourMonths.length" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" v-for="(item, index) in newPatientFourMonths" :key="index">{{ item.ininitdate.substring(item.ininitdate.length-2, item.ininitdate.length) + '월' }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="border border-solid d-theme-border-grey-light text-center" v-for="(item, index) in newPatientFourMonths" :key="index">
                                        {{ item.patientCount }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </vx-card>
                </div>

                <div class="vx-col w-full sm:w-1/1 lg:w-1/1 mb-base">
                    <vx-card title="원장별 담당 환자수">
                        <table id="list" style="width:100%;" class="border-collapse">
                            <thead>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" v-for="(item, index) in doctor_list" :key="index">{{ item.MEDICAL_NM }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="border border-solid d-theme-border-grey-light text-center" v-for="(item, index) in doctor_list" :key="index">{{ item.CNT }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </vx-card>
                </div>
                <!-- <div class="vx-col w-full sm:w-1/1 lg:w-1/1 mb-base">
                    <vx-card title="상담예약">
                        <table id="list" style="width:100%;" class="border-collapse">
                            <thead>
                                <tr>
                                    <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" v-for="(item, index) in doctor_cs" :key="index">{{ item.MANAGER_NM }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="border border-solid d-theme-border-grey-light text-center" v-for="(item, index) in doctor_cs" :key="index">{{ item.TOTAL }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </vx-card>
                </div> -->
            </div>
            
            <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
                <vx-card title="신입/재입 비율">
                    <canvas id="new_re_chart"></canvas>
                </vx-card>
            </div>
            <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
                <vx-card title="본병원">
                    <canvas id="hospital_chart"></canvas>
                </vx-card>
            </div>

            <div class="vx-col w-full sm:w-1/1 lg:w-1/1 mb-base">
                <vx-card title="당일치료실 예약 현황">
                    <table id="list" style="width:100%;" class="border-collapse">
                        <colgroup>
                            <col v-for="(item, index) in today1" :key="index" :width="today1.length" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" v-for="(item, index) in today1" :key="index">{{ item.MEDICAL_NM }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="border border-solid d-theme-border-grey-light text-center" v-for="(item, index) in today1" :key="index">
                                    <a href="javascript:void(0);" @click="chartDetail1(index)">{{ item.TOTAL }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </vx-card>
            </div>
            <div class="vx-col w-full sm:w-1/1 lg:w-1/1 mb-base">
                <vx-card title="당일 외래치료실 예약 현황">
                    <table id="list" style="width:100%;" class="border-collapse">
                        <colgroup>
                            <col v-for="(item, index) in today2" :key="index" :width="today2.length" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header" v-for="(item, index) in today2" :key="index">{{ item.MEDICAL_NM }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="border border-solid d-theme-border-grey-light text-center" v-for="(item, index) in today2" :key="index">
                                    <a href="javascript:void(0);" @click="chartDetail2(index)">{{ item.TOTAL }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </vx-card>
            </div>
        </div>

        <vs-popup :title="chart_title" :active.sync="chart_open">
            <div class="vx-row">
                <div class="vx-col w-full xl:w-1/1 mb-base text-center" style="display:flex; flex-direction:row; justify-content:center;">
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonth"></vs-button>

                    <span class="ml-5 mr-5 mt-2">{{ this.now_date.substring(0, 4) }}년{{ this.now_date.substring(4, 6) }}월</span>

                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonth"></vs-button>
                </div>
            </div>
            <div style="width:100%;overflow:auto;">
                <div class="vx-col w-full xl:w-1/1 mb-base text-center">
                    <canvas id="chart_detail"></canvas>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import Chart from 'chart.js';
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import moment from "moment";
import $ from 'jquery';
export default {
    data() {
        return {
            doctor_list: [],
            doctor_cs: [],
            today1: [],
            today2: [],
            hospital_nm: [],
            hospital_cnt: [],
            hospital_background: [],
            new_re_nm: [],
            new_re_cnt: [],
            new_re_background: [],
            patient_static: [],
            chart_open: false,
            chart_title: '',
            now_date: '',
            medical_code: '',
            medical_name: '',
            width: window.innerWidth,
            newPatientFourMonths: [],
            newPatientDoctor: [],
            targetDate: '',
            prevTargetDate: '',
            nextTargetDate: '',
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async getInit() {
            const { data } = await axiosClass.get('/api/static', {}, true);
            console.log(data);
            this.doctor_list = data.doctor_list;
            // this.doctor_cs = data.doctor_cs;
            this.today1 = data.today1;
            this.today2 = data.today2;
            
            const patient_chart_data = data.patient_static;
            const patient_chart_data_2 = data.patient_static_2;
            
            for (let i = 0; i < data.hospital.length; i++) {
                this.hospital_nm.push(data.hospital[i].MEDICAL_NAME);
                this.hospital_cnt.push(data.hospital[i].TOTAL);
                this.hospital_background.push('#' + Math.floor(Math.random() * 16777215).toString(16));
            }

            for (let i = 0; i < data.new_re.length; i++) {
                this.new_re_nm.push(data.new_re[i].NEW_RE);
                this.new_re_cnt.push(data.new_re[i].TOTAL);
                this.new_re_background.push('#' + Math.floor(Math.random() * 16777215).toString(16));
            }
            
            this.patientChartDetail(patient_chart_data);
            this.patientChart(patient_chart_data_2);
            
            // 20230509 TH 추가
            this.newPatientFourMonths = data.patient_static_4months;
            const newPatientDoctor = data.patient_static_doctor;

            this.patientChartDoctor(newPatientDoctor);
        },

        patientChartDetail(chart_data) {
            let label_array = [];
            let value_array1 = [];
            let value_array2 = [];
            let value_array3 = [];
            for (let i = 0; i < chart_data.length; i++) {
                label_array.push(chart_data[i].YMD.substring(6, 8));
                value_array1.push(chart_data[i].STATUS_5);
            }

            const ctx = document.getElementById('patient_chart_default');
            const myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: label_array,

                    datasets: [
                        {
                            label: '재원환자',
                            data: value_array1,
                            backgroundColor: '#37A2EB',
                            borderColor: '#37A2EB',
                            fill: false,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                    },
                    animation: {
                        duration: 1,
                        onComplete: function() {
                            var chartInstance = this.chart,
                                ctx = chartInstance.ctx;
                            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                            ctx.fillStyle = 'purple';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';

                            this.data.datasets.forEach(function(dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function(bar, index) {
                                    var data = dataset.data[index];
                                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                });
                            });
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 2,
                                    fontSize: 14,
                                },
                            },
                        ],
                    },
                },
            });
        },
        patientChart(chart_data) {
            let label_array = [];
            let value_array1 = [];
            let value_array2 = [];
            let value_array3 = [];
            for (let i = 0; i < chart_data.length; i++) {
                label_array.push(chart_data[i].YMD.substring(8, 10));
                value_array1.push(chart_data[i].STATUS_1);
                value_array2.push(chart_data[i].STATUS_2);
                value_array3.push(chart_data[i].STATUS_3);
            }

            const ctx = document.getElementById('patient_chart');
            const myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: label_array,

                    datasets: [
                        {
                            label: '입원',
                            data: value_array1,
                            backgroundColor: '#37A2EB',
                            borderColor: '#37A2EB',
                            fill: false,
                        },
                        {
                            label: '퇴원',
                            data: value_array2,
                            backgroundColor: '#4AC0C0',
                            borderColor: '#4AC0C0',
                            fill: false,
                        },
                        {
                            label: '외래',
                            data: value_array3,
                            backgroundColor: '#FF6384',
                            borderColor: '#FF6384',
                            fill: false,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: 'Chart.js Line Chart',
                        },
                    },
                    animation: {
                        duration: 1,
                        onComplete: function() {
                            var chartInstance = this.chart,
                                ctx = chartInstance.ctx;
                            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                            ctx.fillStyle = 'purple';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';

                            this.data.datasets.forEach(function(dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function(bar, index) {
                                    var data = dataset.data[index];
                                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                });
                            });
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 2,
                                    fontSize: 14,
                                },
                            },
                        ],
                    },
                },
            });
        },
        createChart(chartId) {
            const ctx = document.getElementById(chartId);
            const myChart = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels: this.hospital_nm,
                    datasets: [
                        {
                            data: this.hospital_cnt,
                            backgroundColor: this.hospital_background,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    plugins: {
                        maintainAspectRatio: false,
                        legend: {},
                        datalabels: {
                            backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                            },
                            borderColor: 'white',
                            borderRadius: 30,
                            borderWidth: 2,
                            color: function(context) {
                                return context.hovered ? 'black' : '#6e6d6d';
                            },
                            font: {
                                weight: 'normal',
                            },
                            listeners: {
                                enter: function(context) {
                                    context.hovered = true;
                                    return true;
                                },
                                leave: function(context) {
                                    context.hovered = false;
                                    return true;
                                },
                            },
                            display: true,
                            formatter: function(value, context) {
                                let sum = 0;
                                let valueArr = this.doughnutChart.datasets[0].data;
                                for (var i in valueArr) {
                                    sum += parseInt(valueArr[i]);
                                }
                                let percentage = ((value * 100) / sum).toFixed(2) + '%';
                                return percentage;
                            }.bind(this),
                        },
                    },
                },
            });
        },
        createChartNewRe(chartId) {
            const ctx = document.getElementById(chartId);
            const myChart = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels: this.new_re_nm,
                    datasets: [
                        {
                            data: this.new_re_cnt,
                            backgroundColor: this.new_re_background,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    plugins: {
                        datalabels: {
                            formatter: (value, ctx) => {
                                let sum = 0;
                                let dataArr = ctx.chart.data.datasets[0].data;
                                dataArr.map(data => {
                                    sum += data;
                                });
                                let percentage = ((value * 100) / sum).toFixed(2) + '%';
                                return percentage;
                            },
                            color: '#fff',
                        },
                    },
                },
            });
        },
        async chartDetail1(index) {
            this.chart_open = true;
            this.chart_title = this.today1[index].MEDICAL_NM;
            const date = this.$moment().format('YYYYMM');
            this.now_date = date;
            this.medical_code = this.today1[index].MEDICAL_CD;
            this.medical_name = this.today1[index].MEDICAL_NM;
            this.chartDataReturn(this.today1[index].MEDICAL_CD, this.today1[index].MEDICAL_NM, date);
        },

        async chartDetail2(index) {
            this.chart_open = true;
            this.chart_title = this.today2[index].MEDICAL_NM;
            // console.log(this.today2[index]);
            const date = this.$moment().format('YYYYMM');
            this.now_date = date;
            this.medical_code = this.today2[index].MEDICAL_CD;
            this.medical_name = this.today2[index].MEDICAL_NM;

            await this.chartDataReturn(this.today2[index].MEDICAL_CD, this.today2[index].MEDICAL_NM, date);
        },

        async prevMonth() {
            this.now_date = dateClass.prevYYYYMM(this.now_date);
            await this.chartDataReturn(this.medical_code, this.medical_name, this.now_date);
        },

        async nextMonth() {
            this.now_date = dateClass.nextYYYYMM(this.now_date);
            await this.chartDataReturn(this.medical_code, this.medical_name, this.now_date);
        },
        async nowStatic() {
            const { data } = await axiosClass.post('/api/static/nowStatic', {}, true);

            this.$vs.notify({
                title: 'Success',
                text: '최신 통계가 적용되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });

            setTimeout(() => {
                this.$vs.loading.close('#schedule > .con-vs-loading');
            }, 100);
        },
        async chartDataReturn(medical_code, meidcal_nm, date) {
            console.log(medical_code);
            console.log(date);

            const { data } = await axiosClass.get('/api/static/reservation/' + medical_code + '/' + date, {}, true);
            // console.log(data);
            let label_array = [];
            let value_array = [];
            for (let i = 0; i < data.chart_data.length; i++) {
                label_array.push(data.chart_data[i].YMD.substring(6, 8));
                value_array.push(data.chart_data[i].TOTAL);
            }

            const ctx = document.getElementById('chart_detail');
            let myChart = null;
            myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: label_array,

                    datasets: [
                        {
                            label: meidcal_nm,
                            data: value_array,
                            // backgroundColor: this.new_re_background,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'top',
                        },
                        title: {
                            display: true,
                            text: 'Chart.js Polar Area Chart',
                        },
                    },
                    animation: {
                        duration: 1,
                        onComplete: function() {
                            var chartInstance = this.chart,
                                ctx = chartInstance.ctx;
                            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                            ctx.fillStyle = 'purple';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';

                            this.data.datasets.forEach(function(dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function(bar, index) {
                                    var data = dataset.data[index];
                                    ctx.fillText(data, bar._model.x, bar._model.y - 5);
                                });
                            });
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 2,
                                    fontSize: 14,
                                },
                            },
                        ],
                    },
                },
            });
        },

        // 20230509 TH 추가
        patientChartDoctor(chart_data) {
            let label_array = [];
            let value_array1 = [];
            let value_array2 = [];
            let value_array3 = [];
            let value_array4 = [];
            let value_array5 = [];
            let value_array6 = [];
            let value_array7 = [];
            let value_array8 = [];
            let value_array9 = [];
            let value_array10 = [];
            let value_array11 = [];
 
            for (let i = 0; i < chart_data.length; i++) {
                label_array.push(chart_data[i].YMD.substring(8, 10));
                
                value_array1.push(chart_data[i].kimjiho);
                value_array2.push(chart_data[i].koojail);
                value_array3.push(chart_data[i].yoonseonghun);
                value_array4.push(chart_data[i].jeonjeongheon);
                value_array5.push(chart_data[i].hanyeonsu);
                value_array6.push(chart_data[i].jeongyoonjin);
                value_array7.push(chart_data[i].jeonginho);
                value_array8.push(chart_data[i].jinyeoungmoon);
                value_array9.push(chart_data[i].kwonhoyeong);
                value_array10.push(chart_data[i].kimjeonggwon);
                value_array11.push(chart_data[i].kweumchungsu);
            }

            const ctx = document.getElementById('patientChartDoctor');
            const myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: label_array,
    
                    datasets: [
                        {
                            label: '김지호 원장님',
                            data: value_array1,
                            backgroundColor: '#37A2EB',
                            borderColor: '#F78181',
                            fill: false,
                        },
                        {
                            label: '구자일 원장님',
                            data: value_array2,
                            backgroundColor: '#37A2EB',
                            borderColor: '#F5D0A9',
                            fill: false,
                        },
                        // {
                        //     label: '윤성훈 원장님',
                        //     data: value_array3,
                        //     backgroundColor: '#37A2EB',
                        //     borderColor: '#37A2EE',
                        //     fill: false,
                        // },
                        // {
                        //     label: '전정헌 원장님',
                        //     data: value_array4,
                        //     backgroundColor: '#F4FA58',
                        //     borderColor: '#F4FA58',
                        //     fill: false,
                        // },
                        {
                            label: '한연수 원장님',
                            data: value_array5,
                            backgroundColor: '#82FA58',
                            borderColor: '#82FA58',
                            fill: false,
                        },
                        // {
                        //     label: '정윤진 원장님',
                        //     data: value_array6,
                        //     backgroundColor: '#58FAD0',
                        //     borderColor: '#58FAD0',
                        //     fill: false,
                        // },
                        // {
                        //     label: '정인호 원장님',
                        //     data: value_array7,
                        //     backgroundColor: '#2E64FE',
                        //     borderColor: '#2E64FE',
                        //     fill: false,
                        // },
                        // {
                        //     label: '진영문 원장님',
                        //     data: value_array8,
                        //     backgroundColor: '#8000FF',
                        //     borderColor: '#8000FF',
                        //     fill: false,
                        // },
                        // {
                        //     label: '권호영 원장님',
                        //     data: value_array9,
                        //     backgroundColor: '#FF00BF',
                        //     borderColor: '#FF00BF',
                        //     fill: false,
                        // },
                        {
                            label: '김정권 원장님',
                            data: value_array10,
                            backgroundColor: '#8000FF',
                            borderColor: '#8000FF',
                            fill: false,
                        },
                        {
                            label: '금충수 원장님',
                            data: value_array11,
                            backgroundColor: '#FF00BF',
                            borderColor: '#FF00BF',
                            fill: false,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    layout:{
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0,
                        }
                    },
                    plugins: {
                        legend: {
                            position: 'top',
                            maxHeight: 50,
                        },
                        title: {
                            display: true,
                            text: 'Chart.js Line Chart',
                            padding: 100
                        },                        
                    },
                    animation: {
                        duration: 1,
                        onComplete: function() {
                            var chartInstance = this.chart,
                                ctx = chartInstance.ctx;
                            ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                            ctx.fillStyle = 'purple';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';

                            this.data.datasets.forEach(function(dataset, i) {
                                var meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function(bar, index) {
                                    var data = dataset.data[index];
                                    ctx.fillText(data, bar._model.x, bar._model.y + 15);
                                });
                            });
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 2,
                                    fontSize: 14,
                                },

                            },
                        ],
                    },
                },
            });

            
        },
        // 20230509 TH 추가
        async prevMonthNewPatient() {
            this.prevTargetDate = moment(this.targetDate).add(-1, 'months');
            this.prevTargetDate = moment(this.prevTargetDate).format('YYYYMMDD');
            await this.renewNewPatientbyDoctor(this.prevTargetDate);
        },
        // 20230509 TH 추가
        async nextMonthNewPatient() {
            this.nextTargetDate = moment(this.targetDate).add(1, 'months');
            this.nextTargetDate = moment(this.nextTargetDate).format('YYYYMMDD');
            await this.renewNewPatientbyDoctor(this.nextTargetDate);
        },
        // 20230509 TH 추가
        async renewNewPatientbyDoctor (targetDate) {
            const { data } = await axiosClass.get('/api/static/renewNewPatientbyDoctor/' + targetDate, {}, true);
            const newPatientDoctor = data.patient_static_doctor;
            this.targetDate = targetDate;
            console.log(targetDate);

            let patientChartDoctorChart = document.getElementById('patientChartDoctor');
            let patientChartDoctorBtn = $('#patientChartDoctorBtn');

            patientChartDoctorChart.remove();
            patientChartDoctorBtn.after('<canvas id="patientChartDoctor"></canvas>');
            

            this.patientChartDoctor(newPatientDoctor);
        },
    },
    async mounted() {
        window.addEventListener('resize', this.handleResize);
        this.now_date = dateClass.dateYYYYMM();
        this.targetDate = dateClass.dateYYYYMM();
        await this.getInit();
        this.createChart('hospital_chart');
        this.createChartNewRe('new_re_chart');
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style>
.con-vs-popup .vs-popup {
    width: 900px;
}
#patientChartDoctor {
    margin-top: 10px;
}
</style>
